import React, { useEffect } from 'react';
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Stack,
    Select,
    Text,
    Box,
} from '@chakra-ui/react'
import Input from './Input';
import { useState } from 'react';
import { FaProductHunt, FaUser, FaUserAlt } from "react-icons/fa";
import Button from './Button';
import { CreateShelf, CreateUser, GetAllCategories, GetAllStores, TransferStoreApi, UpdateBinAPi, UpdateProductShelf } from '../Utils/ApiCalls';
import { SiQuantcast } from 'react-icons/si';
import { CgProductHunt } from 'react-icons/cg';
import { ImPriceTags } from 'react-icons/im';
import MsgCallback from './MsgCallback';
import { isEmergency } from '../Authetication';
import { TbNumber0, TbNumber1, TbNumber2 } from 'react-icons/tb';



export default function UpdateBinRecord({ isOpen, onClose, updatedPayload }) {


    console.log("updatedPayload", updatedPayload)
    const [Payload, setPayload] = useState({
        minimum: "",
        maximum: "",
        reorder: "",
    });

    const [CurrentPayload, setCurrentPayload] = useState({
        minimum: "",
        maximum: "",
        reorder: "",
    });






    const [errorMsg, setErrorMsg] = useState({
        status: false,
        msg: ""
    });

    const [SuccessMsg, setSuccessMsg] = useState({
        status: false,
        msg: ""
    });


    const [Loading, setLoading] = useState(false);

    const handleUpdatedBin = (e) => {
        setPayload({ ...Payload, [e.target.id]: e.target.value })

    }







    const UpdateBin = async () => {

        try {
            setLoading(true)
            let result = await UpdateBinAPi(Payload, updatedPayload[0]._id);
            // console.log("result", result);
            if (result.status === true) {
                setLoading(false)
                setSuccessMsg({
                    status: true,
                    msg: "Bin Updated Successfully"
                })

                setPayload({
                    minimum: "",
                    maximum: "",
                    reorder: "",
                })

                setTimeout(() => {
                    setSuccessMsg({
                        status: false,

                    })
                }, 3000);

            } else {
                setLoading(false)
                setErrorMsg({
                    status: true,
                    msg: result.msg
                })

                setTimeout(() => {
                    setErrorMsg({
                        status: false,

                    })
                }, 3000);

            }


        } catch (e) {

            setLoading(false)
            setErrorMsg({
                status: true,
                msg: e.message
            })
            console.error('Error:', e.message);
        }



    }


    useEffect(() => {

        setPayload({
            minimum: updatedPayload[0]?.minimum,
            maximum: updatedPayload[0]?.maximum,
            reorder: updatedPayload[0]?.reorder,
        })
    }, [isOpen]);

    return (



        <Modal isOpen={isOpen} onClose={onClose} isCentered>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Update Bin Record for </ModalHeader>
                <ModalCloseButton />
                <ModalBody>

                    <Box>
                        <Stack spacing={"15px"}>
                            <Input leftIcon={<TbNumber0 />} iconColor="black" labelBg='#fff' label='minimum' id="minimum" type='number' value={Payload.minimum} val={Payload.minimum != "" ? true : false} onChange={handleUpdatedBin} />
                            <Input leftIcon={<TbNumber1 />} iconColor="black" labelBg='#fff' label='maximum' id="maximum" type='number' value={Payload.maximum} val={Payload.maximum != "" ? true : false} onChange={handleUpdatedBin} />
                            <Input leftIcon={<TbNumber2 />} iconColor="black" labelBg='#fff' label='reorder' id="reorder" type='number' value={Payload.reorder} val={Payload.reorder != "" ? true : false} onChange={handleUpdatedBin} />



                        </Stack>

                        <Button mt="14px" isLoading={Loading}
                            disabled={Payload.minimum != "" && Payload.maximum != "" && Payload.reorder != "" ? false : true}
                            onClick={UpdateBin}>Update</Button>

                        <MsgCallback errorMsg={errorMsg} SuccessMsg={SuccessMsg} />

                    </Box>



                </ModalBody>

                <ModalFooter>


                </ModalFooter>
            </ModalContent>
        </Modal>

    )
}
